var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPublished = function SvgPublished(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.861 6.853a2.39 2.39 0 0 1 2.39-2.39h7.003a2.39 2.39 0 0 1 2.39 2.39v5.656a2.39 2.39 0 0 1-2.39 2.39H5.252a2.39 2.39 0 0 1-2.39-2.39zm2.39-1.38a1.38 1.38 0 0 0-1.38 1.38v5.656c0 .762.618 1.38 1.38 1.38h7.003a1.38 1.38 0 0 0 1.38-1.38V6.853a1.38 1.38 0 0 0-1.38-1.38z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.703 8.671a.168.168 0 0 0-.29.051l-.915 2.67a.168.168 0 0 0 .159.223h5.836a.168.168 0 0 0 .137-.266l-1.197-1.694a.168.168 0 0 0-.26-.018l-.523.554c-.49.52-1.325.488-1.773-.068zm-1.246-.276a1.178 1.178 0 0 1 2.031-.359L8.662 9.49c.064.079.184.083.254.01l.522-.555c.51-.542 1.39-.48 1.82.128l1.197 1.694a1.178 1.178 0 0 1-.962 1.859H5.657a1.178 1.178 0 0 1-1.115-1.56z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.12 7.406a.673.673 0 1 1-1.348 0 .673.673 0 0 1 1.347 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.682 3.711A1.366 1.366 0 0 0 2.62 5.32l.927 4.6a.5.5 0 1 1-.98.198l-.928-4.6a2.366 2.366 0 0 1 1.838-2.785l2.985-.62c.975-.202 2.235-.44 3.222-.622 1.165-.215 2.324.472 2.643 1.634.116.422.231.872.312 1.26a.5.5 0 1 1-.98.204 20 20 0 0 0-.296-1.199 1.295 1.295 0 0 0-1.497-.916c-.986.182-2.237.418-3.2.618z",
    clipRule: "evenodd"
  })));
};
export default SvgPublished;